import * as React from "react";

export const userTrackingContext = React.createContext({ isReady: false });
